class InclusiveToggle {
	constructor( button ) {
		this.button = button;
		this.target = document.getElementById( button.getAttribute( 'aria-controls' ) );
		return this;
	}

	open() {
		const event = document.createEvent( 'Event' );
		event.initEvent( 'open', true, true );
		this.button.setAttribute( 'aria-expanded', true );
		this.target.setAttribute( 'aria-hidden', false );
		this.button.dispatchEvent( event );
		return this;
	}

	close() {
		const event = document.createEvent( 'Event' );
		event.initEvent( 'close', true, true );
		this.button.setAttribute( 'aria-expanded', false );
		this.target.setAttribute( 'aria-hidden', true );
		this.button.dispatchEvent( event );
		return this;
	}

	toggle() {
		const expanded = this.button.getAttribute( 'aria-expanded' ) === 'true';
		return expanded ? this.close() : this.open();
	}

	init() {
		this.button.addEventListener( 'click', this.toggle.bind( this ), false );
	}
}

export default InclusiveToggle;
